import React from 'react';
import type { FC } from 'react';
import isUnicodeSupported from 'is-unicode-supported';
import { Text } from '../components/Text.js';

export const Cart: FC = () => {
  return <Text>{isUnicodeSupported() ? '🛒' : '>'}</Text>;
};
